import { useMemo } from 'react';

import { Spin } from 'antd';

import type {
    KpiAxisConfiguration,
    KpiBinLabelAffixes,
} from 'components/molecules/PackArchitecture/kpiAxisConfiguration.utils';
import { buildKpiPreview } from 'components/molecules/PackArchitecture/kpiAxisConfiguration.utils';

type KpiAxisConfigurationModalPreviewProps = {
    config: KpiAxisConfiguration;
    binLabelAffixes?: KpiBinLabelAffixes;
    previewLabels?: string[];
    isLoading?: boolean;
};

const KpiAxisConfigurationModalPreview = ({
    config,
    binLabelAffixes,
    previewLabels,
    isLoading = false,
}: KpiAxisConfigurationModalPreviewProps) => {
    const previewResult = useMemo(() => {
        if (previewLabels !== undefined) {
            return {
                bins: previewLabels.map((label) => ({ label, start: 0, end: 0 })),
                binCount: previewLabels.length,
                binSize: 0,
                breakpoints: [],
            };
        }

        return buildKpiPreview(config, binLabelAffixes);
    }, [binLabelAffixes, config, previewLabels]);

    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <div>
                <p className="m-0 mb-3 text-xs font-medium text-breadcrumbSlash">
                    Preview ({previewResult.binCount})
                </p>
            </div>
            <div className="relative min-h-0 max-h-[275px] flex-1 overflow-y-auto rounded-lg bg-axisModalBg px-[4px] py-[4px] pl-[8px]">
                {isLoading ? (
                    <div className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/60">
                        <Spin size="small" />
                    </div>
                ) : null}
                <ol className="m-0 list-decimal pl-5">
                    {previewResult.bins.map((bin, index) => (
                        <li
                            key={`${bin.start}-${bin.end}-${index}`}
                            className="mb-1 text-sm font-normal leading-[22px] text-toolbarLabelGrey"
                        >
                            {bin.label}
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    );
};

export default KpiAxisConfigurationModalPreview;
